import { useState } from 'react';
import { Stack, Title, Tabs, Text, Group, Badge, Skeleton, Alert } from '@mantine/core';
import { IconCreditCard, IconFileInvoice, IconAlertCircle } from '@tabler/icons-react';
import { formatBillingDate } from '@/shared/utils/date';
import { useBillingPlan } from '../../hooks/useBilling';
import { PaymentMethodTab } from './PaymentMethodTab';
import { InvoicesTab } from './InvoicesTab';

export function BillingPage() {
  const [activeTab, setActiveTab] = useState<string | null>('payment');
  const { billingPlan, isLoading, isError } = useBillingPlan();
  const nextBilling = billingPlan ? formatBillingDate(billingPlan.expires) : null;

  return (
    <Stack gap="lg">
      <Group justify="space-between" align="flex-start">
        <div>
          <Title order={2}>Billing</Title>
          {billingPlan && (
            <Group gap="sm" mt={4}>
              <Badge variant="light" size="lg">
                {billingPlan.billingPlan.publicLabel || billingPlan.billingPlan.name}
              </Badge>
              {nextBilling && (
                <Text size="sm" c="dimmed">
                  Next billing: {nextBilling}
                </Text>
              )}
            </Group>
          )}
          {isLoading && <Skeleton height={24} width={200} mt={4} />}
          {isError && (
            <Alert color="red" icon={<IconAlertCircle size={16} />} mt="xs">
              Failed to load billing plan information.
            </Alert>
          )}
        </div>
      </Group>

      <Tabs value={activeTab} onChange={setActiveTab} aria-label="Billing sections">
        <Tabs.List>
          <Tabs.Tab value="payment" leftSection={<IconCreditCard size={16} />}>
            Payment Method
          </Tabs.Tab>
          <Tabs.Tab value="invoices" leftSection={<IconFileInvoice size={16} />}>
            Invoices
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="payment" pt="md">
          <PaymentMethodTab />
        </Tabs.Panel>

        <Tabs.Panel value="invoices" pt="md">
          <InvoicesTab />
        </Tabs.Panel>
      </Tabs>
    </Stack>
  );
}
